// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20709172","584":"6c207a19","732":"0654699c"}[chunkId] + ".chunk.js";
};